<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :actions="false"
                :parentData="parentData"
                ref="master"
      >
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
//
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'retefte_hist',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Procedimiento', dataIndex: 'rte_procedimiento', sorter: true},
              {title: 'Porcentaje', dataIndex: 'rte_porcentaje', sorter: true},
              {title: 'Prom. salud', dataIndex: 'prm_salud', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Fecha final', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Ded. vivienda', dataIndex: 'ded_vivienda', sorter: true},
              {title: 'Ded. vivienda anual', dataIndex: 'ded_viv_anual', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'fecha_inicio_viv', sorter: true},
              {title: 'Fecha final', dataIndex: 'fecha_fin_viv', sorter: true},
              {title: 'Ded. salud', dataIndex: 'ded_salud', sorter: true},
              {title: 'Ded. salud anual', dataIndex: 'ded_sal_anual', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'fecha_inicio_sal', sorter: true},
              {title: 'Fecha final', dataIndex: 'fecha_fin_sal', sorter: true},
              {title: 'Ded. dependiente', dataIndex: 'dependiente_desc', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'fecha_inicio_dep', sorter: true},
              {title: 'Fecha final', dataIndex: 'fecha_fin_dep', sorter: true},
              {title: 'Declarante', dataIndex: 'declarante_desc', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'start_date_dec', sorter: true},
              {title: 'Fecha final', dataIndex: 'end_date_dec', sorter: true},
              {title: 'Fecha creacion', dataIndex: 'created_on', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Fecha creacion hist', dataIndex: 'created_on_hist', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by_hist', sorter: true}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    },
    methods: {
      consultarDatos () {
        this.$refs.master.$refs.datatable.loadData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeRetefteHist.vue